/*
  Our Story (round 28): the movements of sections/vr-story.liquid. Each plays once, or follows the reader:
  - things appear once as they come into view (.vrs-in), and photographs open from the middle like the doors
    (.vrs-door); the signature writes itself in;
  - the manifesto's words come to ink one by one as it is read;
  - in the karkhana the step in the middle of the window is the one lit, and the picture beside it follows (a step
    with more photographs shows them one after another, slowly, while it is read);
  - in the journey a thread of gold is drawn down the years as they are reached, and each year fills with gold;
  - the wax seal of the promise is pressed once as it comes into view (a CSS transition on .vrs-in);
  - the press quotes turn every few seconds, and hold under the pointer, for the keyboard and out of view;
  - each collection's wordmark is cropped to its ink, so marks drawn with different margins stand at one height;
  - a campaign film plays over the page when asked for (the player is made then, and taken away on closing).
  The stores map (India in gold dust) is assets/vr-story-map.js.
  Visitors who ask for reduced motion see the page still and whole.
*/
(function () {
  'use strict';
  var root = document.querySelector('[data-vrs]');
  if (!root || root.getAttribute('data-vrs-ready')) return;
  root.setAttribute('data-vrs-ready', '1');
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (reduce || !('IntersectionObserver' in window)) root.classList.add('is-still');

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function whenSignFont(go) {
    var done = false;
    var finish = function () { if (!done) { done = true; go(); } };
    try { if (document.fonts && document.fonts.load) document.fonts.load('500 64px "VR Signature"').then(finish, finish); else finish(); } catch (e) { finish(); }
    window.setTimeout(finish, 2500);
  }
  function vh() { return window.innerHeight || document.documentElement.clientHeight; }

  /* ---- appear once ---- */
  if (!reduce && 'IntersectionObserver' in window) {
    var once = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        once.unobserve(el);
        /* the signature is written only once its hand has arrived, so it never shows in a stand-in font first */
        if (el.hasAttribute('data-vrs-sign')) { whenSignFont(function () { el.classList.add('is-in'); }); return; }
        if (!el.classList.contains('vrs-door')) { el.classList.add('is-in'); return; }
        /* a photograph opens only once its picture has arrived, so the doors never open on an empty frame */
        var im = el.querySelector('img');
        var open = function () { el.classList.add('is-open'); };
        if (!im || (im.complete && im.naturalWidth)) { open(); return; }
        im.addEventListener('load', open, { once: true });
        im.addEventListener('error', open, { once: true });
        window.setTimeout(open, 2500);
      });
    }, { threshold: 0.22, rootMargin: '0px 0px -6% 0px' });
    root.querySelectorAll('.vrs-in, .vrs-door, .vrs-story__detail, [data-vrs-sign]').forEach(function (el) { once.observe(el); });
    /* a closed photograph does not count as seen, so the browser would put off fetching it: ask for it early instead */
    var early = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        early.unobserve(e.target);
        e.target.querySelectorAll('img').forEach(function (im) { im.loading = 'eager'; });
      });
    }, { rootMargin: '0px 0px 150% 0px' });
    root.querySelectorAll('.vrs-door, .vrs-story__detail').forEach(function (el) { early.observe(el); });
  } else {
    root.querySelectorAll('.vrs-door').forEach(function (el) { el.classList.add('is-open'); });
    root.querySelectorAll('.vrs-in, .vrs-story__detail, [data-vrs-sign]').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---- the manifesto: words to ink as they are read ---- */
  var words = [];
  var manifesto = root.querySelector('[data-vrs-words]');
  if (manifesto) {
    var wrap = function (node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var parts = child.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var w = document.createElement('span');
            w.className = 'vrs-w';
            w.textContent = p;
            frag.appendChild(w);
            words.push(w);
          });
          child.parentNode.replaceChild(frag, child);
        } else if (child.nodeType === 1) {
          wrap(child);
        }
      });
    };
    wrap(manifesto);
    if (reduce) words.forEach(function (w) { w.classList.add('is-lit'); });
  }
  var litCount = -1;
  function updateWords() {
    if (!manifesto || reduce) return;
    var r = manifesto.getBoundingClientRect(), h = vh();
    /* from the paragraph's top at 82% of the window to its foot at 46% */
    var start = h * 0.82, end = h * 0.46;
    var p = clamp((start - r.top) / ((r.height + start - end) || 1), 0, 1);
    var n = Math.round(p * words.length);
    if (n === litCount) return;
    litCount = n;
    for (var i = 0; i < words.length; i++) words[i].classList.toggle('is-lit', i < n);
  }

  /* ---- the karkhana: the step in the middle of the window is lit, the picture follows ---- */
  var craft = root.querySelector('[data-vrs-craft]');
  var stepEls = craft ? Array.prototype.slice.call(craft.querySelectorAll('[data-vrs-step]')) : [];
  var frameEls = craft ? Array.prototype.slice.call(craft.querySelectorAll('[data-vrs-frame]')) : [];
  var activeStep = 0;
  function updateCraft() {
    if (!stepEls.length) return;
    var h = vh(), best = activeStep, bestD = Infinity;
    var gr = craft.getBoundingClientRect();
    if (gr.bottom < 0 || gr.top > h) return;
    if (!cycling) { cycling = true; cycleFrame(); }
    var media = craft.querySelector('.vrs-craft__media');
    /* on phones the picture is pinned at the top: the reading line is below it */
    var line = h * 0.5;
    if (media && window.matchMedia('(max-width: 749.98px)').matches) { var mr = media.getBoundingClientRect(); line = mr.bottom + (h - mr.bottom) * 0.42; }
    stepEls.forEach(function (el, i) {
      var r = el.getBoundingClientRect();
      var d = Math.abs(r.top + r.height / 2 - line);
      if (d < bestD) { bestD = d; best = i; }
    });
    if (best === activeStep) return;
    activeStep = best;
    stepEls.forEach(function (el, i) { el.classList.toggle('is-active', i === best); });
    frameEls.forEach(function (el, i) {
      el.classList.toggle('is-active', i === best);
      var v = el.querySelector('video');
      if (v) { try { if (i === best) v.play(); else v.pause(); } catch (e) {} }
    });
    cycleFrame();
  }
  /* a step with more photographs: they are fetched when it is first read, then follow one another every few seconds
     while it stays lit and the karkhana is on screen; coming back to a step begins again with its first photograph */
  var cycleTimer = 0, cycling = false;
  function cycleFrame() {
    window.clearInterval(cycleTimer);
    cycleTimer = 0;
    var fr = frameEls[activeStep];
    if (!fr) return;
    var pics = Array.prototype.slice.call(fr.querySelectorAll('.vrs-craft__pic'));
    if (pics.length < 2 || reduce) return;
    pics.forEach(function (p, i) {
      var src = p.getAttribute('data-src');
      if (src) { p.removeAttribute('data-src'); p.src = src; }
      p.classList.toggle('is-shown', i === 0);
    });
    var at = 0;
    cycleTimer = window.setInterval(function () {
      var gr = craft.getBoundingClientRect();
      if (gr.bottom < 0 || gr.top > vh() || document.hidden) return;
      var next = (at + 1) % pics.length;
      if (!pics[next].complete || !pics[next].naturalWidth) return;
      pics[at].classList.remove('is-shown');
      pics[next].classList.add('is-shown');
      at = next;
    }, 3800);
  }

  /* ---- the journey: a thread of gold drawn down the years ---- */
  var journey = root.querySelector('[data-vrs-journey]');
  var thread = null;
  function buildThread() {
    if (!journey) return;
    var svg = journey.querySelector('.vrs-thread');
    var base = svg.querySelector('.vrs-thread__base'), live = svg.querySelector('.vrs-thread__live'), knotsG = svg.querySelector('.vrs-thread__knots');
    var miles = Array.prototype.slice.call(journey.querySelectorAll('[data-vrs-mile]'));
    if (!miles.length) return;
    var jr = journey.getBoundingClientRect();
    var W = jr.width, H = jr.height;
    svg.setAttribute('viewBox', '0 0 ' + W.toFixed(1) + ' ' + H.toFixed(1));
    var phone = window.matchMedia('(max-width: 749.98px)').matches;
    var pts = [];
    miles.forEach(function (m, i) {
      var year = m.querySelector('.vrs-mile__year');
      var r = (year || m).getBoundingClientRect();
      var y = (phone ? r.top + r.height * 0.45 : m.getBoundingClientRect().top + m.getBoundingClientRect().height / 2) - jr.top;
      var x = phone ? 14 : W * (i % 2 ? 0.475 : 0.525);
      pts.push({ x: x, y: y });
    });
    var x0 = phone ? 14 : W * 0.5;
    var d = 'M' + x0.toFixed(1) + ' 0';
    var prev = { x: x0, y: 0 };
    pts.concat([{ x: x0, y: H }]).forEach(function (p) {
      var my = (prev.y + p.y) / 2;
      d += ' C' + prev.x.toFixed(1) + ' ' + my.toFixed(1) + ' ' + p.x.toFixed(1) + ' ' + my.toFixed(1) + ' ' + p.x.toFixed(1) + ' ' + p.y.toFixed(1);
      prev = p;
    });
    base.setAttribute('d', d);
    live.setAttribute('d', d);
    var len = live.getTotalLength ? live.getTotalLength() : H;
    live.style.strokeDasharray = len + ' ' + len;
    while (knotsG.firstChild) knotsG.removeChild(knotsG.firstChild);
    var knots = pts.map(function (p) {
      var k = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      var s = phone ? 4.5 : 6;
      k.setAttribute('d', 'M' + p.x + ' ' + (p.y - s) + ' L' + (p.x + s) + ' ' + p.y + ' L' + p.x + ' ' + (p.y + s) + ' L' + (p.x - s) + ' ' + p.y + ' Z');
      k.setAttribute('class', 'vrs-thread__knot');
      knotsG.appendChild(k);
      return k;
    });
    thread = { live: live, len: len, H: H, pts: pts, knots: knots, miles: miles, shown: thread ? thread.shown : 0, target: 0 };
    if (reduce) { thread.shown = 1; drawThread(); }
  }
  function drawThread() {
    if (!thread) return;
    var drawnY = thread.shown * thread.H;
    thread.live.style.strokeDashoffset = (thread.len * (1 - thread.shown)).toFixed(1);
    thread.pts.forEach(function (p, i) {
      var on = drawnY >= p.y - 2;
      thread.knots[i].classList.toggle('is-lit', on);
      thread.miles[i].classList.toggle('is-lit', on);
    });
  }
  function targetThread() {
    if (!thread) return;
    var r = journey.getBoundingClientRect();
    /* the thread reaches as far down as 60% of the window */
    thread.target = clamp((vh() * 0.6 - r.top) / (r.height || 1), 0, 1);
  }

  /* ---- the press: quotes that turn ---- */
  var quotes = root.querySelector('[data-vrs-quotes]');
  if (quotes) {
    var slides = Array.prototype.slice.call(quotes.querySelectorAll('[data-vrs-q]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-vrs-dot]'));
    var at = 0, timer = 0, held = false, seen = false;
    var show = function (i) {
      at = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === at); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === at); if (j === at) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    };
    var stop = function () { window.clearInterval(timer); timer = 0; };
    var start = function () { stop(); if (reduce || held || !seen || document.hidden || slides.length < 2) return; timer = window.setInterval(function () { show(at + 1); }, 6500); };
    dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); start(); }); });
    quotes.addEventListener('pointerenter', function () { held = true; stop(); });
    quotes.addEventListener('pointerleave', function () { held = false; start(); });
    quotes.addEventListener('focusin', function () { held = true; stop(); });
    quotes.addEventListener('focusout', function () { held = false; start(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { seen = entries[0].isIntersecting; if (seen) start(); else stop(); }, { threshold: 0.3 }).observe(quotes);
    }
  }

  /* ---- the films: a player over the page, made only when a film is asked for ---- */
  var film = root.querySelector('[data-vrs-film-modal]');
  if (film) {
    var filmFrame = film.querySelector('.vrs-film__frame');
    var filmTitle = film.querySelector('.vrs-film__title');
    var filmClose = film.querySelector('[data-vrs-film-close]');
    var filmFrom = null, filmTimer = 0;
    var openFilm = function (id, title, from) {
      if (!id) return;
      window.clearTimeout(filmTimer);
      filmFrom = from;
      filmTitle.textContent = title || '';
      while (filmFrame.firstChild) filmFrame.removeChild(filmFrame.firstChild);
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      f.title = title || 'Film';
      f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      f.setAttribute('allowfullscreen', '');
      f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      filmFrame.appendChild(f);
      film.hidden = false;
      document.documentElement.classList.add('vrs-film-open');
      window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { film.classList.add('is-open'); }); });
      filmClose.focus();
    };
    var closeFilm = function () {
      if (film.hidden) return;
      film.classList.remove('is-open');
      document.documentElement.classList.remove('vrs-film-open');
      /* the player goes as the fade begins, so the sound stops at once */
      while (filmFrame.firstChild) filmFrame.removeChild(filmFrame.firstChild);
      filmTimer = window.setTimeout(function () { film.hidden = true; }, reduce ? 0 : 500);
      if (filmFrom && filmFrom.getAttribute('tabindex') !== '-1') filmFrom.focus();
    };
    root.querySelectorAll('[data-vrs-film]').forEach(function (b) {
      b.addEventListener('click', function () { openFilm(b.getAttribute('data-vrs-film'), b.getAttribute('data-vrs-film-title'), b); });
    });
    filmClose.addEventListener('click', closeFilm);
    film.addEventListener('click', function (e) { if (e.target === film || e.target.classList.contains('vrs-film__inner')) closeFilm(); });
    document.addEventListener('keydown', function (e) { if ((e.key === 'Escape' || e.key === 'Esc') && !film.hidden) closeFilm(); });
    /* the keyboard stays with the film while it is open */
    document.addEventListener('focusin', function (e) { if (!film.hidden && film.classList.contains('is-open') && !film.contains(e.target)) filmClose.focus(); });
  }

  /* ---- the wordmarks: cropped to their ink (as in assets/vr-gallery.js) ---- */
  function measureMarks() {
    var boxes = Array.prototype.slice.call(root.querySelectorAll('.vr-index__mark-box[data-vr-mark]'));
    boxes.forEach(function (b) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var W = 240, H = Math.max(1, Math.round(W * im.naturalHeight / im.naturalWidth));
          var c = document.createElement('canvas'); c.width = W; c.height = H;
          var g = c.getContext('2d'); g.drawImage(im, 0, 0, W, H);
          var d = g.getImageData(0, 0, W, H).data;
          var x0 = W, y0 = H, x1 = -1, y1 = -1;
          for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) { if (d[(y * W + x) * 4 + 3] > 40) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
          if (x1 < 0) return;
          var fw = (x1 + 1 - x0) / W, fh = (y1 + 1 - y0) / H, fx = x0 / W, fy = y0 / H;
          var ar = (fw * im.naturalWidth) / (fh * im.naturalHeight);
          var px = fw >= 0.999 ? 50 : fx / (1 - fw) * 100, py = fh >= 0.999 ? 50 : fy / (1 - fh) * 100;
          b.style.setProperty('--ink-ar', ar.toFixed(4));
          b.style.setProperty('--ink-boost', Math.min(1.42, Math.max(0.78, Math.sqrt(1.7 / ar))).toFixed(3));
          b.style.setProperty('--ink-size', (100 / fw).toFixed(2) + '% ' + (100 / fh).toFixed(2) + '%');
          b.style.setProperty('--ink-pos', px.toFixed(2) + '% ' + py.toFixed(2) + '%');
          b.classList.add('is-measured');
        } catch (e) { /* a file the canvas may not read: shown whole */ }
      };
      im.src = b.getAttribute('data-vr-mark');
    });
  }

  /* ---- one frame for everything that follows the page ---- */
  var ticking = false, smoothing = false;
  function frame() {
    ticking = false;
    updateWords();
    updateCraft();
    targetThread();
    if (!smoothing) { smoothing = true; window.requestAnimationFrame(smooth); }
  }
  function smooth() {
    var busy = false;
    if (thread) {
      var dT = thread.target - thread.shown;
      if (Math.abs(dT) > 0.0005) { thread.shown += dT * 0.1; busy = true; } else thread.shown = thread.target;
      drawThread();
    }
    if (busy) window.requestAnimationFrame(smooth); else smoothing = false;
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(frame); } }

  var built = false;
  function build() { buildThread(); built = true; onScroll(); }
  var resizeTimer = 0;
  window.addEventListener('resize', function () { window.clearTimeout(resizeTimer); resizeTimer = window.setTimeout(build, 180); });
  if (!reduce) window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', build);
  if (window.ResizeObserver && journey) { try { new ResizeObserver(function () { if (built) { window.clearTimeout(resizeTimer); resizeTimer = window.setTimeout(build, 180); } }).observe(journey); } catch (e) {} }
  build();
  if ('requestIdleCallback' in window) window.requestIdleCallback(measureMarks, { timeout: 2000 }); else window.setTimeout(measureMarks, 600);
})();
